import { Button, Modal, Spacer, StringTemplate, Text } from '@oy/uidesktop';
import { useTranslate } from 'src/hooks';
import styles from './ConfirmationModal.module.css';

export const CloseModalConfirmation = ({
  showCloseModal,
  onCancelCloseModalConfirmation,
  onCloseModalConfirmation,
}: {
  showCloseModal: boolean;
  onCancelCloseModalConfirmation: () => void;
  onCloseModalConfirmation: () => void;
}) => {
  const { getTranslation } = useTranslate();
  return (
    <Modal show={showCloseModal} disableOnClose className={styles.width480}>
      <Modal.Header>
        {getTranslation('close_modal_sign_legal_title')}
      </Modal.Header>
      <Modal.Body>
        <Text textStyle={Text.Style.BodyLgRegular}>
          {getTranslation('close_modal_sign_legal_description_1')}
        </Text>
        <Spacer top={Spacer.Size.M} />
        <Text textStyle={Text.Style.BodyLgRegular}>
          <StringTemplate
            str={getTranslation('close_modal_sign_legal_description_2')}
            template={{
              emailKyb: (
                <a href={`mailto:${import.meta.env.VITE_KYB_EMAIL}`}>
                  {import.meta.env.VITE_KYB_EMAIL}
                </a>
              ),
            }}
          />
        </Text>
        <Spacer top={Spacer.Size.XXL} />
        <div className={styles.displayFlex}>
          <Button
            className={styles.flex_1}
            fullWidth
            buttonType={Button.Type.Outlined}
            onClick={onCancelCloseModalConfirmation}
          >
            {getTranslation('common_status_cancel')}
          </Button>
          <Button
            className={styles.flex_1}
            fullWidth
            color={Button.Color.Destructive}
            onClick={onCloseModalConfirmation}
          >
            {getTranslation('integration_deleteModal_yes')}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
